import Vue from 'vue'
import Vuex from 'vuex'
// import products from './service'
import Mocks from '../Mocks'
import axios from 'axios';
import {IService} from '../types';

declare global {
    interface Window {
        locale: any;
    }
}

class ApiService {

    static get(endpoint: string): any {
        endpoint = process.env.VUE_APP_API_BASE + endpoint;
        const promise = new Promise((resolve, reject) => {
            axios.get(endpoint).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                console.log(error);
            });
        });

        return promise
    }

    static post(endpoint: string, payload: any): any {
        endpoint = process.env.VUE_APP_API_BASE + endpoint;
        const promise = new Promise((resolve, reject) => {
            axios.post(endpoint, payload).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                console.log(error);
            });
        });
        return promise
    }
}

Vue.use(Vuex);

type Type = {
    id: string;
}

type Filter = {
    facets: string[];
    type?: Type[]
}

type Category = {
    id: string;
    node: {
        children: Category[];
        name: string;
    };
}

type ResultFilter = {
    facets_terms: {
        [x: string]: string[];
    };
    facets_count: {
        [x: string]: string[];
    };
}

type State = {
    status: {
        results: string;
    }
    search: {
        query: null | string;
        category: null | string;
        filter: { [x: string]: any };
        options: { [x: string]: any };
    }
    filter: Filter | null;
    categories: Category[] | null;
    categoriesMap: {
        [x: string]: string;
    } | null;
    language: string | null;
    fallbackLanguage: string;
    service: IService | null;
    results: { [x: string]: any } | null;
    services: IService[] | null;
    selections: {
        service: IService | null,
        searchFilter: string[],
        resultLanguage: null | string;
    },
    resultFilter: ResultFilter | null;
}

export default new Vuex.Store<State>({
    strict: true,
    plugins: [],
    state: {
        status: {
            results: 'finished'
        },
        search: {
            query: null,
            category: null,
            filter: {},
            options: {}
        },
        filter: null,
        categories: null,
        categoriesMap: null,
        language: null,
        fallbackLanguage: 'en',
        service: null,
        results: null,
        services: null,
        selections: {
            service: null,
            searchFilter: [],
            resultLanguage: null
        },
        resultFilter: null
    },
    getters: {
        isSearchCategory: (state) => (id: string) => {
            const category = state.search.category;

            return category && category.indexOf(id) >= 0;
        },
        isActiveService: (state) => (id: any) => {
            const service = state.selections.service;

            return service && service.id === id;
        },
        findCategoryById: (state) => (category: any) => {
            if (!category)
                return;

            // @ts-ignore
            if (!state)
                return;

            // @ts-ignore
            let pathString = state.categoriesMap[category];

            if (!pathString)
                return;

            let path = pathString.split('/');
            let current: any;
            current = {children: state.categories};

            for (let i = 1; i < path.length; i++) {
                let levelID = path[i];// @ts-ignore

                let child = current.children.find((node: any) => node.id == levelID);

                if (!child)
                    break;
                current = child;
            }
            return current;
        }
    },
    mutations: {
        init(state, payload) {
            state.services = payload.services;
        },
        setLanguage(state, payload) {
            state.language = payload;
        },
        selectService(state, id) {
            let $service;
            // @ts-ignore
            let selectedService = state.services.find(service => service.id == id) || null;

            if (state.selections.service == selectedService) {
                return;
            }

            state.selections.service = selectedService;

            state.results = null;
            state.filter = null;
            // @ts-ignore
            state.selections.searchFilter = [];
            state.status.results = 'finished';      // @ts-ignore
            //state.selections.searchFilter = null;
        },
        selectSearchCategory(state, category) {
            const categories = (state.search.category || "").split(",").map(x => x.trim()).filter(x => !!x)

            const index = categories.indexOf(category)
            if (index >= 0) {
                categories.splice(index, 1)
            } else {
                categories.push(category)
            }
            state.search.category = categories.join(",")
        },
        setResultLanguage(state, resultLanguage) {
            state.selections.resultLanguage = resultLanguage;
        },
        setCategories(state, categories) {
            state.categories = categories;
        },
        setFilter(state, facets) {
            state.filter = facets;
        },
        searchFilterSelection(state, filter) {
            state.selections.searchFilter = filter;
        },
        results(state, results) {
            state.results = results;
            state.status.results = 'finished';
        },
        resultFilter(state, results) {
            state.resultFilter = results;
        },
        categoriesMap(state, map) {
            state.categoriesMap = map;
        },
        setSearchQuery(state, query) {
            state.search.query = query;
        },
        setSearchFilter(state, filter) {
            state.search.filter = filter;
        },
        setSearchOptions(state, options) {
            state.search.options = options;
        },
        setOptions(state, options) {
            state.search.options = options;
        },
        resultsStatus(state, status) {
            state.status.results = status;
        },
        updateStatus(state, status) {
            Object.assign(state.status, status);
        }

    },
    actions: {
        async fetchCategoriesMap() {
            let self = this;
            try {
                let results = await new Promise((resolve, reject) => {
                    axios.get(process.env.VUE_APP_API_BASE + '/api/service/search/categories/map').then((response) => {
                        resolve(response.data);
                        self.commit('categoriesMap', response.data);
                    });
                });

                return results;

            } catch (e) {
                console.log(e);
            }


        },
        getResultsCount({
            state,      // same as `store.state`, or local state if in modules
            commit,     // same as `store.commit`
        }, payload) {

            let $state = state;
            let service: any = 'search';
            if (state.selections.service !== null) {
                // @ts-ignore
                service = state.selections.service.id;
            }

            let promise = ApiService.post('/api/service/' + service + '/results/count', payload);

            promise.then((result: any) => {

            });

            return promise;
        },
        getResults({
            state,      // same as `store.state`, or local state if in modules
            rootState,  // same as `store.state`, only in modules
            commit,     // same as `store.commit`
            dispatch,   // same as `store.dispatch`
            getters,    // same as `store.getters`, or local getters if in modules
            rootGetters // same as `store.getters`, only in modules
        }, payload) {
            const {query, category, filter, options} = state.search;

            if (!payload) {
                payload = {
                    indices: category,
                    query,
                    filter,
                    options
                };
            }

            payload.locale = window.locale;

            if (payload.options && !payload.options.resetQuery) {
                commit('resultsStatus', 'updating');
            } else {
                // @ts-ignorerktest
                commit('results', []);
                commit('searchFilterSelection', []);
                commit('resultFilter', null);
                commit('resultsStatus', 'loading');
            }

            try {
                let $state = state;
                const service = (state.selections.service && state.selections.service.id) || "search";

                let promise = ApiService.post(
                    '/api/service/' + service + '/results',
                    payload
                );

                promise.then((result: any) => {
                    // @ts-ignore
                    commit('results', result.results);
                    if (payload.options && !payload.options.resetQuery) {
                        // @ts-ignore
                        if ((!result.meta || result.meta.length == 0) && $state.resultFilter.facets_terms) {
                            result.meta = {
                                facets_terms: {},
                                facets_count: {}
                            };
                            // @ts-ignore
                            result.meta.facets_terms = $state.resultFilter.facets_terms;
                            // @ts-ignore
                            for (let id in $state.resultFilter.facets_count) {
                                // @ts-ignore
                                if ($state.resultFilter.facets_count.hasOwnProperty(id)) {
                                    // @ts-ignore
                                    result.meta.facets_count[id] = [];
                                }
                            }
                        }
                        commit('resultFilter', result.meta);
                    } else {
                        // @ts-ignore
                        commit('resultFilter', result.meta);
                    }
                });
                promise.catch((error: any) => {
                    commit('resultsStatus', 'error');
                    console.log(error);
                });

            } catch (e) {
                console.log(e);
            }

        },
        getServices({commit}) {

            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    commit('init', {
                        services: Mocks.services,
                    });
                    resolve();
                }, 100)
            });

        },
        fetchCategories({commit}) {
            return new Promise((resolve, reject) => {
                axios.get(process.env.VUE_APP_API_BASE + '/api/service/downloads/categories/locale/' + window.locale).then((response) => {
                    commit('setCategories', response.data);
                    resolve();
                });
            });
        },
        fetchFilters({commit}) {

            let $this = this;
            return new Promise((resolve, reject) => {
                axios.get(process.env.VUE_APP_API_BASE + '/api/service/downloads/filters').then((response) => {
                    commit('setFilter', response.data.facet);
                    resolve();
                });
            })

        }
    }
})
